import { Ref } from 'vue';

import {
  ClientReferenceNumberType,
  DropdownOption,
  ReferenceNumberValueType,
} from '@rygen/rygen-ui/model';

import { ReferenceNumber } from '@/model';

export const formatReferenceNumberValue = (
  referenceNumberValueOptionsMap: Ref<
    Map<string, Map<unknown, DropdownOption<unknown>>>
  >,
  clientRefNum: ClientReferenceNumberType,
  refNum: ReferenceNumber,
) => {
  const refNumNaturalId = clientRefNum.referenceNumberType?.naturalId!;
  const valueOptionsMap =
    referenceNumberValueOptionsMap.value.get(refNumNaturalId);

  const isDate =
    clientRefNum.referenceNumberType?.valueType ===
    ReferenceNumberValueType.DATE;
  const isDateTime =
    clientRefNum.referenceNumberType?.valueType ===
    ReferenceNumberValueType.DATETIME;
  const isTime =
    clientRefNum.referenceNumberType?.valueType ===
    ReferenceNumberValueType.TIME;

  if (isDate) {
    return refNum.valueAsDateTime?.toFormat('MM/dd/yy');
  } else if (isDateTime) {
    return refNum.valueAsDateTime?.toFormat('MM/dd/yy, hh:mm a');
  } else if (isTime) {
    return refNum.valueAsDateTime?.toFormat('hh:mm a');
  } else {
    return valueOptionsMap?.get(refNum.value)?.label ?? refNum.value;
  }
};
